import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { useCsvExport } from 'lib/hooks/useCsvExport.tsx'
import { useAtomValue } from 'jotai'
import {
  selectedCustomFieldColumnsAtom,
  selectedCustomFieldFiltersAtom
} from 'modules/BillingSchedules/billingSchedules.atoms'

const parseBooleanQueryParam = (
  value: string | null | undefined,
  defaultValue: boolean | undefined = undefined
) => {
  switch (value) {
    case 'true':
      return true
    case 'false':
      return false
    default:
      return defaultValue
  }
}

type UseBillingSchedulesCsvExport = () => {
  download: {
    available: boolean
    disabled: boolean
    onClick: (queryParams: URLSearchParams) => void
  }
}

export const useBillingSchedulesCsvExport: UseBillingSchedulesCsvExport =
  () => {
    const customFieldKeys = useAtomValue(selectedCustomFieldColumnsAtom)
    const customFieldFilters = useAtomValue(selectedCustomFieldFiltersAtom)

    return useCsvExport({
      getExport: queryParams =>
        dashboardv99990101Client.getBillingSchedulesCsvDownload({
          customerId: queryParams.get('customerId') ?? undefined,
          includeArchivedSchedules: parseBooleanQueryParam(
            queryParams.get('includeArparseBooleanQueryParamchivedSchedules'),
            false
          ),
          billingScheduleStatus:
            queryParams.get('billingScheduleStatus') ?? undefined,
          label: queryParams.get('label') ?? undefined,
          autoSendInvoices: parseBooleanQueryParam(
            queryParams.get('autoSendInvoices')
          ),
          startingBefore: queryParams.get('startingBefore') ?? undefined,
          startingAfter: queryParams.get('startingAfter') ?? undefined,
          endingBefore: queryParams.get('endingBefore') ?? undefined,
          endingAfter: queryParams.get('endingAfter') ?? undefined,
          includeOpenEndedSchedules: parseBooleanQueryParam(
            queryParams.get('includeOpenEndedSchedules')
          ),
          includeCustomFields:
            customFieldKeys.length > 0 ? customFieldKeys : undefined,
          customFieldFilters:
            Object.keys(customFieldFilters).length > 0
              ? customFieldFilters
              : undefined
        }),
      fileName: 'billing-schedules-export.csv'
    })
  }
